import {
  BigDotIcon,
  Box,
  CheckIcon,
  CloseIcon,
  GKButton,
  Grid2,
  IconButton,
  Typography,
} from "components";
import { AdvisorOnboardFormInterface } from "interfaces/OnboardingInterface";
import { useFormContext } from "react-hook-form";

const SendClientModal = ({ setOpen }: { setOpen: (d: boolean) => void }) => {
  const form = useFormContext<AdvisorOnboardFormInterface>();

  return (
    <Grid2 container borderRadius={2}>
      <Grid2 size={12} p={2} textAlign={"right"}>
        <IconButton
          onClick={() => {
            form.reset();
            setOpen(false);
          }}
        >
          <CloseIcon width={28} height={28} />
        </IconButton>
      </Grid2>
      <Grid2
        size={12}
        px={2}
        textAlign={"center"}
        gap={1}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          p={2}
          bgcolor={"var(--primary-50)"}
          borderRadius={100}
        >
          <CheckIcon color="var(--primary-900)" width={26} height={26} />
        </Box>
        <Typography fontSize={20} fontWeight={700}>
          Invitation Sent
        </Typography>
        <Typography fontSize={12} color="var(--grey-500)">
          Onboarding link has been sent to{" "}
          {form.getValues("personalDetails.name")} at:
        </Typography>
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <Typography color="var(--grey-500)" fontSize={12}>
            {form.getValues("personalDetails.email")}
          </Typography>
          <BigDotIcon color="var(--grey-500)" />
          <Typography fontSize={12} color="var(--grey-500)">
            {form.getValues("phone")}
          </Typography>
        </Box>
      </Grid2>
      <Grid2 size={12} p={2} textAlign={"right"}>
        <GKButton
          variant="outlined"
          color="dark"
          onClick={() => {
            form.reset();
            setOpen(false);
          }}
        >
          Close
        </GKButton>
      </Grid2>
    </Grid2>
  );
};

export default SendClientModal;
